import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const DEFAULT_TAG_COLOR = '#6B7280';

export const TagPill = styled.span`
  background: ${({color}) => color || DEFAULT_TAG_COLOR};
  border-radius: 3px;
  color: #fff;
  display: inline-block;
  font-size: 11px;
  line-height: 1.3;
  padding: ${({size}) => (size === 'small' ? '2px 7px' : '2px 8px')};
  white-space: nowrap;
`;

const CrmTagPill = ({color, label, small}) => (
  <TagPill color={color} size={small ? 'small' : undefined}>
    {label}
  </TagPill>
);

CrmTagPill.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  small: PropTypes.bool,
};

export default CrmTagPill;
